<fgb-banner [pageTitle]="'games.banner.text' | translate" />

<fgb-page-header [pageTitle]="'games.banner.text'" [backButtonLink]="'/'"></fgb-page-header>

<div class="container mt-lg-3">
  <div class="game-container-sections">
    <div>
      <img src="assets/images/games/trivia-cover.jpg" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.trivia' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/quiz'">
          <div class="btn btn-secondary">{{ 'games.page.trivia.play' | translate }}</div>
        </div>
      </div>
    </div>

    <div>
      <img src="assets/images/games/polls-cover.jpg" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.polls' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.polls.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/polls'">
          <div class="btn btn-secondary">{{ 'games.page.polls.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="game-container-sections mt-4">
    <div>
      <img src="assets/images/games/predictor-cover.jpg" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.predictor' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/predictor'">
          <div class="btn btn-secondary">{{ 'games.page.predictor.play' | translate }}</div>
        </div>
      </div>
    </div>
    <div>
      <img src="assets/images/games/pick-a-player-cover.jpg" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.pap' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.pap.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/pickaplayer'">
          <div class="btn btn-secondary">{{ 'games.page.pap.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
